const ConnectedDevicesLoadingState = ({ message = 'Loading data...' }) => {
  return (
    <div className="d-flex h-100 w-100 align-items-center justify-content-center text-white">
      <div className="d-flex align-items-center gap-2">
        <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ConnectedDevicesLoadingState;
